export const lookupZipCode = async (zipCode) => {
  if (!zipCode || zipCode.length !== 5) {
    return { state: "", city: "" };
  }

  try {
    // Fallback a API externa
    const response = await fetch(`http://api.zippopotam.us/us/${zipCode}`);
    if (response.ok) {
      const data = await response.json();
      return {
        state: data.places[0]["state abbreviation"],
        city: data.places[0]["place name"],
      };
    } else {
      throw new Error("Código postal no encontrado");
    }
  } catch (error) {
    console.error("Error al buscar código postal:", error);
    throw error;
  }
};
